import Vue from "vue";
import EventBus from "@/events/eventbus";

const initialState = () => ({
  persistedCachedRoutes: {},
  ignoreSave: {},
});

const state = initialState();

const actions = {
  cacheRoute({ commit }, { route, component, data }) {
    commit("ADD_CACHE_ROUTE_STATE", { route, component, data });
  },
  removePersistedCachedRoute({ commit }, route) {
    commit("REMOVE_CACHE_ROUTE_STATE", route);
    commit("CLEAN_UP_SUSPICIOUS_ROUTES");
  },
  cleanIgnore({ commit }) {
    commit("CLEAN_IGNORE");
  },
  reset({ commit }) {
    commit("CLEAR_CACHE");
  },
};

const mutations = {
  ADD_CACHE_ROUTE_STATE: (state, { route, component, data }) => {
    if (route in state.ignoreSave) return;

    if (!state.persistedCachedRoutes[route]) {
      Vue.set(state.persistedCachedRoutes, route, {});
    }

    Vue.set(state.persistedCachedRoutes[route], component, data);

    EventBus.$emit("persisted-cached-routes-updated");
  },
  CLEAN_UP_SUSPICIOUS_ROUTES(state) {
    // We would treat as suspicious all routes with less than 4 components
    // that's because all our pages should have more than that and sometimes
    // we've found that some routes remain in cache with one component only.
    Object.entries(state.persistedCachedRoutes)
      .filter(([, components]) => Object.values(components).length < 4)
      .forEach(([route]) => Vue.delete(state.persistedCachedRoutes, route));

    EventBus.$emit("persisted-cached-routes-updated");
  },
  REMOVE_CACHE_ROUTE_STATE: (state, route) => {
    Vue.delete(state.persistedCachedRoutes, route);
    Vue.set(state.ignoreSave, route, new Date().getTime());

    EventBus.$emit("persisted-cached-routes-updated");
  },
  CLEAN_IGNORE: (state) => {
    // 15 sec before adding to cache again
    const time = new Date().getTime() - 15000;
    for (let route in state.ignoreSave) {
      if (state.ignoreSave[route] < time) {
        Vue.delete(state.ignoreSave, route);
      }
    }
  },
  CLEAR_CACHE: (state) => {
    Vue.set(state, "persistedCachedRoutes", {});
    Vue.set(state, "ignoreSave", {});

    EventBus.$emit("persisted-cached-routes-updated");
  },
};

const getters = {
  persistedCachedRoutes: (state) => state.persistedCachedRoutes,
  ignoreSave: (state) => state.ignoreSave,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
